import { z } from "zod";

export type IdOrIdentifier = number | string;

export const idOrIdentifierSchema = z.union([z.number({ coerce: true }), z.string()]);
